import * as React from 'react';
import * as classNames from 'classnames';

export type Size = 'small' | 'large' | 'fluid';
export type Color = 'white' | 'orange';

interface IProps {
  size?: Size;
  color?: Color;
}

function getBars(size) {
  const bars = [];
  const barCount = size === 'small' ? 3 : 5;

  for (let i = 0; i < barCount; i++) {
    bars.push({ id: i });
  }

  return bars;
}

function LoadingBars(props: IProps) {
  const { size, color } = props;

  const classes = classNames('loading-bars', {
    'loading-bars--small': size === 'small',
    'loading-bars--large': size === 'large',
    'loading-bars--fluid': size === 'fluid',
    'loading-bars--white': color === 'white',
    'loading-bars--orange': color === 'orange',
  });

  return (
    <div className={classes}>
      <div className="loading-bars__inner">
        {getBars(size).map(wing => (
          <div key={wing.id} className="loading-bars__bar" />
        ))}
      </div>
    </div>
  );
}

export default LoadingBars;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/loading_bars.tsx